var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accont"},[_c('div',{staticClass:"container mt-5 mb-5"},[_c('div',{staticClass:"row accont-title mb-2"},[_vm._v("Configuración de cuenta")]),_c('AccontInfo'),_c('BankInfo'),_c('ChangePassword')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }